type CompactTableDateProps = {
  value?: string | null
  includeTime?: boolean
  includeYear?: boolean
  includeWeekday?: boolean
  locale?: string
  timeZone?: string
}

const parseDateValue = (value: string) => {
  const raw = value.trim()
  if (!raw) {
    return null
  }

  const hasExplicitTimeZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(raw)
  const hasClockTime = /\d{2}:\d{2}/.test(raw)
  const normalized = raw.includes(' ') ? raw.replace(' ', 'T') : raw

  if (hasClockTime && !hasExplicitTimeZone) {
    return new Date(`${normalized}Z`)
  }

  return new Date(normalized)
}

export function CompactTableDate({
  value,
  includeTime = true,
  includeYear = true,
  includeWeekday = false,
  locale,
  timeZone,
}: CompactTableDateProps) {
  if (!value) {
    return <span className="text-muted-foreground">-</span>
  }

  const parsed = parseDateValue(value)
  if (!parsed) {
    return <span className="text-muted-foreground">-</span>
  }

  if (!Number.isFinite(parsed.getTime())) {
    return <span className="text-muted-foreground">-</span>
  }

  const dateLabel = parsed.toLocaleDateString(locale, {
    weekday: includeWeekday ? 'short' : undefined,
    day: '2-digit',
    month: 'short',
    year: includeYear ? 'numeric' : undefined,
    timeZone,
  })

  if (!includeTime) {
    return <span className="text-xs font-medium text-foreground">{dateLabel}</span>
  }

  return (
    <span className="flex flex-col gap-0.5">
      <span className="text-xs font-medium text-foreground">{dateLabel}</span>
      <span className="text-xs text-muted-foreground">
        {parsed.toLocaleTimeString(locale, {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
          timeZone,
        })}
      </span>
    </span>
  )
}

/** Matches bookings/orders table wrapper typography. */
export const commerceTableClassName = 'text-sm leading-5'
